import { useUserUpdateRoleMutation } from '~/generated/graphql';

export function useUpdateRole() {
  const [updateRole, { loading }] = useUserUpdateRoleMutation();

  return {
    updateRole,
    loading,
  };
}
